import { connect } from "react-redux";
import _ from "underscore";
import { PASSED_QUIZZES, QUIZ_PERFORMANCE, getBarColors } from "./GraphUtility";
import { providePopulateData } from "components/utility/hoc/PopulateData";
var {STAT_DISPLAY, formatTimestamp} = require("components/data/graphs/GraphUtility")

var DataSelectors = require("lib/selectors/DataSelectors")
var DataActions = require("lib/actions/DataActions");
var Spinner = require("components/utility/Spinner");

@connect(
	(state, props) => ({
        digests: DataSelectors.digests({ state, filters: {entity_id: props.entity.id, entity_type: props.entityType, graph: true} })
	}),
	(dispatch, props) => {
        var fetchDigests = (entityType, entityID) => {
            var conditions = {entityType: entityType, entityID: entityID }
            return dispatch(DataActions.fetchDigests({
                conditions: conditions,
                query: {digest_summary: true, graph_digests_only: true},
                cache: false
            }))
        }

        var populateData = () => {
            return Promise.all([
				fetchDigests(props.entityType, props.entity.id)
			])
        }

        return {
            fetchDigests,
            populateData
        }
    }
)
@providePopulateData({waitForLoad: true})
class DigestProgressGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        this.state = {
            digests: [],
            loadingDigests: false,
            loadedDependencies: false
        }
    }

    // fetch digests for the type of group that is being shown.
    fetchData(){
        this.setState({loadingDigests: true})
                
        this.props.fetchDigests(this.props.entityType, this.props.entity.id).then(res=>{
            this.setState({loadingDigests: false})
        })
    }
    // can't tell what month a digest corresponds to directly, so figure it out by taking mid point
    // of digest. 
    getMonthFromDigest(digest){
        if (!digest.start_date || !digest.end_date) { return }
        var monthStart = new Date(digest.start_date)
        var monthEnd = new Date(digest.end_date)
        var midpoint = new Date((monthStart.getTime() + monthEnd.getTime()) / 2)
        return formatTimestamp(midpoint.getTime())
    }

    // takes in data key, and digest. Returns digest name, and formatted metric
    formatData(digest, metricKey){
        var metric = digest.data[metricKey]
        var formatFunc = STAT_DISPLAY[metricKey]['formatting']
        if (formatFunc){
            metric = formatFunc(metric)
        }

        return {"metric": metric, "name": STAT_DISPLAY[metricKey]['name']}
    }

    createEmptyData(){
        var startMonth = _.get(this.props.entity, ['prefs', 'school_year_start_month'], 8)
        
        var now = new Date()
        if (startMonth <= now.getMonth()) {
            var startYear = now.getFullYear()
        } else {
            var startYear = now.getFullYear() - 1
        }

        var emptyMonth = new Date(startYear, startMonth)

        var data = []
        while (emptyMonth <= now) {
            var emptyData = {"Month": formatTimestamp(emptyMonth.getTime())}
            this.props.metrics.forEach(metric=>{
                var metricName = STAT_DISPLAY[metric].name
                emptyData[metricName] = 0
            })
            
            data.push(emptyData)
            emptyMonth = new Date(emptyMonth.getFullYear(), emptyMonth.getMonth() + 1)
        }
        return data
    }

    // create data organized as necessary to display.
    createData(){
        if (this.state.loadingDigests || !this.state.loadedDependencies) {return}

        var digests = [...this.props.digests]

        if (digests.length == 0) { return this.createEmptyData() }

        digests.sort(function(a,b){
            return new Date(a.start_date) - new Date(b.start_date);
        });

        var data = []
        var now = new Date()
        for (var i = 0; i < digests.length; i++){
            var digest = digests[i]
           
            if (now < new Date(digest.start_date)) { continue }
            
            var dataCol = {}
            dataCol['Month'] = this.getMonthFromDigest(digest)

            // if there is a custom data extraction function for this specific data
            if (STAT_DISPLAY[this.props.metrics[0]]['data_extraction_func']){
                dataCol = STAT_DISPLAY[this.props.metrics[0]]['data_extraction_func'](digest, dataCol)
            } else { // extract data the generic way.
                var formattedData = this.formatData(digest, this.props.metrics[0])
                dataCol[formattedData['name']] = formattedData['metric']
    
                if (this.props.metrics.length == 2) {
                    var formattedData = this.formatData(digest, this.props.metrics[1])
                    dataCol[formattedData['name']] = formattedData['metric']
                }
            }
            data.push(dataCol)
        }

        return data
    }

    DigestProgressGraph(){
        var data = this.createData()
        // grab metrics from first row of data
        var metricsToGraph = []
        _.each(data[0], (value, metric)=>{
            if (metric != "Month") {metricsToGraph.push(metric)}    
        })

        var colors = getBarColors(metricsToGraph)
        var unit = STAT_DISPLAY[this.props.metrics[0]].unit
        var domain = STAT_DISPLAY[this.props.metrics[0]].domain
        return (
            <div>
                <Recharts.BarChart width={730} height={250} data={data}>
                    <Recharts.CartesianGrid strokeDasharray="3 3" />
                    <Recharts.XAxis dataKey="Month" />
                    {/* Random key forces the axis to re-render ticks when data changes... Bug in recharts. */}
                    <Recharts.YAxis key={Math.random()} unit={unit} domain={domain}/>
                    <Recharts.Tooltip />
                    <Recharts.Legend />
                    <Recharts.Bar dataKey={metricsToGraph[0]} fill={colors[0]} unit={unit}/>
                    {metricsToGraph.length == 2 && <Recharts.Bar dataKey={metricsToGraph[1]} fill={colors[1]} />}
                </Recharts.BarChart>
            </div>
        )
    }
    
    render(){
        if (!this.state.loadedDependencies || this.state.loadingDigests) {
            var graph = <Spinner/>
        } else {
            var graph = this.DigestProgressGraph()
        }
        
        return (
            <div className='ScoringGraph'>
                {graph}
            </div>
        )
    }

    componentDidMount(){
        $wr.loadScript("/dependencies/recharts.min.js", "Recharts", () => {
			this.setState({ loadedDependencies: true });
		});
    }

    componentDidUpdate(prevProps){
        if (!_.isEqual(prevProps.entity, this.props.entity)){
            this.fetchData()
        }
    }
}

DigestProgressGraph.propTypes = PageStrictPropTypes({
    entity: PropTypes.object,
    entityType: PropTypes.string,
    metrics: PropTypes.array
});

module.exports = DigestProgressGraph


// WEBPACK FOOTER //
// ./modules/components/data/graphs/DigestProgressGraph.js